import * as signalR from "@microsoft/signalr";
class SignalRService {
  private static instance: SignalRService;
  private connection: signalR.HubConnection;
  private constructor() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_API_URL_FOR_CHAT + "userActivityHub", {
          accessTokenFactory: async () => {
              return localStorage.getItem("token")||""; // Fetch JWT token from localStorage
          },
          transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling
      }) // Replace with your actual hub URL
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }
  public static getInstance(): SignalRService {
    if (!SignalRService.instance) {
      SignalRService.instance = new SignalRService();
    }
    return SignalRService.instance;
  }
  public async startConnection(): Promise<void> {
    try {
      if (this.connection.state === signalR.HubConnectionState.Disconnected) {
        await this.connection.start();
        console.log("SignalR Connected");
      }
    } catch (error) {
      console.error("SignalR Connection Error:", error);
      setTimeout(() => this.startConnection(), 5000); // Retry after 5 sec
    }
  }
  public async stopConnection(): Promise<void> {
    try {
      await this.connection.stop();
      console.log("SignalR Disconnected");
    } catch (error) {
      console.error("SignalR Disconnection Error:", error);
    }
  }

  public getConnection(): signalR.HubConnection {
    return this.connection;
  }
}

export default SignalRService.getInstance();
